import { RatingBadgeTheme } from "../RatingBadge.types";
import { palette } from "../../../../../theming/bca/bca-palette";

const theme: RatingBadgeTheme = {
	base: {
		backgroundColor: palette.hexFor("tertiary_1_100"),
		".Typography": {
			color: palette.hexFor("tertiary_1_800"),
		},
		".Icon svg": {
			fill: palette.hexFor("tertiary_1_400"),
		},
	},
};

export default theme;
